<template>
  <v-expansion-panels accordion v-model="showPanel" class="base-shadow">
    <v-expansion-panel expand>
      <v-expansion-panel-header>
        <content-line icon="custom/settings" text="Manage Entertainment" />
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <div class="pa-4">
          <p>
            You can use a video URL and/or Spotify playlist. Then, when desired,
            use the "Turn Off" button below to pull everyone back to the
            meeting.
          </p>

          <field-block class="mb-2">
            <v-select
              label="VideoUrl"
              v-model="context.state.videoUrl"
              :items="actionData.videos"
              @change="updateEntertain"
              class="background-dark"
            />
          </field-block>
          <field-block class="mt-2 mb-2">
            <v-select
              label="Playlist Url"
              v-model="context.state.audioUrl"
              :items="actionData.audios"
              @change="updateEntertain"
              class="background-dark"
            />
          </field-block>

          <v-btn
            class="mt-4"
            :class="showEntertain ? '' : 'primary'"
            @click.prevent="toggleEntertain(false)"
          >
            {{ showEntertain ? 'Turn Off' : 'Turn On' }}
          </v-btn>
          <v-btn
            class="mt-4 ml-3"
            text
            color="primary"
            @click.prevent="$emit('close')"
          >
            Close
          </v-btn>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: 'ActionEntertainControls',
  props: {
    context: {
      type: Object,
      default: () => ({}),
    },
    actionData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showPanel: 0,
    };
  },
  computed: {
    showEntertain() {
      return this.context.state.show;
    },
  },
  methods: {
    toggleEntertain() {
      this.context.state.show = !this.showEntertain;
      this.updateEntertain();
    },
    updateEntertain() {
      this.$emit('update');
    },
    assignData() {
      const keysPairs = { audioUrl: 'audios', videoUrl: 'videos' };
      for (let key in keysPairs) {
        const entertainOptions = this.actionData[keysPairs[key]];
        if (!this.context.state[key] && entertainOptions) {
          this.context.state[key] = entertainOptions[0].value;
        }
      }
    },
  },

  mounted() {
    this.assignData();
  },
};
</script>

<style scoped>
.headline {
  cursor: pointer;
}
</style>
